import { bindActionCreators } from '@reduxjs/toolkit';
import { toastActions } from '../store/toast';
import { useAppDispatch, useAppSelector } from './useRedux';

export const useToast = () => {
  const dispatch = useAppDispatch();
  const toast = useAppSelector((state) => state.toast);
  const { show, hide } = bindActionCreators(toastActions, dispatch);

  const success = (message: string) => show({ message, severity: 'success' });
  const error = (message: string) => show({ message, severity: 'error' });
  const info = (message: string) => show({ message, severity: 'info' });
  const warning = (message: string) => show({ message, severity: 'warning' });

  return {
    success,
    error,
    info,
    warning,
    hide,
    ...toast,
  };
};
